<template>
  <div class="official-event-link">
    <div class="off-event-box">
      <img src="http://images.snsports.cn/event_link_bg.png?imageView2/2/w/700">
    </div>
    <div class="off-footer-box display-flex-end">
      <div class="off-btn-item red" v-if="false"><div>联系顾问</div></div>
      <div class="off-btn-item yellow" @click="goTrial"><div>立即咨询</div></div>
    </div>
  </div>
</template>

<script>
import { getAppPath, varConfig, ImageFormat } from '@/utils'

export default {
  name: 'officialEventLink',
  data() {
    return {
    }
  },
  created() {

  },
  mounted() {
    this.shareData = {
      title: '办赛工具',
      link: this.getShareLink(),
      image: ImageFormat.squareImageView('FiyWzstnQ98KV_cqnYgPkCljISPc', 120)
    }
    this.wxShare(this.shareData)
  },
  methods: {
    goTrial() {
      const path = getAppPath('webapplt')
      const url = `${varConfig.siteUrl}/${path}/index/index.html#/reservation?type=3&result=办赛工具`
      window.location.href = url
    },
    getShareLink: function () {
      const arr = window.location.href.split('index.html')
      return arr[0] + 'index.html#/official-eventLink?v=1'
    }
  }
}
</script>

<style lang="stylus" scoped>
  .official-event-link {
    .off-event-box{
      width: 100%;
      position: relative;
      padding-bottom: 51px;
      img{
        width: 100%;
        height: 100%;
        position: relative;
        top: 0;
        left: 0;
      }
    }
    .off-footer-box{
      position: fixed;
      bottom: 0;
      width: 100%;
      max-width: 480px;
      height: 50px;
      background: rgba(255, 255, 255, 0.8);
      padding: 4px 0;
      .off-btn-item{
        display: inline-block;
        padding: 4px 17px;
        border-radius: 24px;
        color: #FFFFFF;
        cursor: pointer;
      }
      .red{
        background: linear-gradient(180deg, #F56767 0%, #9D3A38 100%);
        margin-right: 15px;
      }
      .yellow{
        background: linear-gradient(180deg, #F9AF0E 0%, #B67016 100%);
        margin-right: 38px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/official-eventLink/index.vue